import React, { createContext, ReactNode, useContext } from 'react'

interface PanelContextValue {
  isFullscreen?: boolean
}

const PanelContext = createContext<PanelContextValue | undefined>(undefined)

interface PanelContextProviderProps {
  children: ReactNode
  isFullscreen?: boolean
}

export const PanelContextProvider: React.FC<PanelContextProviderProps> = ({
  children,
  isFullscreen = false,
}) => {
  const value: PanelContextValue = {
    isFullscreen,
  }

  return <PanelContext.Provider value={value}>{children}</PanelContext.Provider>
}

export const usePanelContext = (): PanelContextValue => {
  const context = useContext(PanelContext)
  if (context === undefined) {
    throw new Error(
      'usePanelContext must be used within a PanelContextProvider'
    )
  }
  return context
}
